import { useCallback, useState } from "react"
import { retrieveRewardLeaderboard, retrieveRewardReferral, retrieveRewardTicket } from "src/pages/admin/services/whitelistService"
import { Referral, RewardTier, Tier } from "./List"

const useReward = () => {

  const [tickets, setTickets] = useState<Tier[]>([])
  const [leaderboard, setLeaderboard] = useState<RewardTier[]>([])
  const [referrals, setReferrals] = useState<Referral[]>([])

  const retrieveTickets = useCallback(async () => {
    try {
      const response = await retrieveRewardTicket()
      setTickets(response.data)
    } catch (error) {
      console.log("retrive reward tickets error: ", error)
      throw error
    }
  }, [])

  const retrieveLeaderboard = useCallback(async () => {
    try {
      const response = await retrieveRewardLeaderboard()
      setLeaderboard(response.data)
    } catch (error) {
      console.log("retrive reward leaderboard error: ", error)
      throw error
    }
  }, [])

  const retrieveReferral = useCallback(async() => {
    try {
      const response = await retrieveRewardReferral()
      setReferrals(response.data)
    } catch (error) {
      console.log("retrive reward referral error: ", error)
      throw error
    }
  }, [])


  return {
    retrieveTickets,
    tickets,
    retrieveLeaderboard,
    leaderboard,
    retrieveReferral,
    referrals
  }
}

export default useReward